import { Layout } from '../../common/components';
import GenerateReport from '../sharedComponents/generateReport/generateReport';
import AccountingAutomatedReports from './accountingAutomatedReports/AccountingAutomatedReports';

const Reports = () => {
  return (
    <Layout>
      <AccountingAutomatedReports />
      <GenerateReport page="reports" />
    </Layout>
  );
};

export default Reports;
